<template>
    <div>
        <inner-page-banner-component></inner-page-banner-component>

        <main class="shared-hosting ptb100">
            <!-- Section Title -->
            <div class="section-title">
                <h2>Shared Web Hosting Done Right</h2>
                <p>When building a website, start here. Our shared service delivers a powerful, proven platform that's
                    perfect for hosting your websites.</p>
            </div>

            <section class="pricing-offers">
                <div class="row">

                    
                    <!-- Start of Pricing Table -->
                    <div :key="product.name" v-for="product in products" :class="{'col-md-3': true, 'pricing-plan': !product.featured, 'pricing-plan-featured': !!product.featured }">
                        <div itemscope="" itemtype="http://schema.org/Product" class="price-box">
                            <h5><strong> <span itemprop="name">{{ product.name }}</span></strong></h5>
                            <span itemprop="offers" itemscope="" itemtype="http://schema.org/AggregateOffer">
                     <span style="display: none" itemprop="priceCurrency">USD</span>
                     <h2>
                        <sup>$</sup><span itemprop="price">{{ product.price }}</span>
                     </h2>
                     <span style="display: none" itemprop="lowPrice">{{ product.price }}</span>
                  </span>
                            <div itemprop="description" class="price-features">
                                <p :key="index" v-for="feature, index in product.features">{{ feature }}</p>
                               
                            </div>
                            <a :href="productLink(product.pid)"
                               class="btn btn-blue btn-effect">signup now</a>
                        </div>
                    </div>
                    <!-- End of Featured Pricing Table -->
           
                </div>
            </section>

            
            <frequently-asked-questions-component></frequently-asked-questions-component>

        </main>

        <footer-component></footer-component>
    </div>
</template>

<script>
    import InnerPageBannerComponent from "./partials/InnerPageBannerComponent";
    import FrequentlyAskedQuestionsComponent from "./partials/FrequentlyAskedQuestionsComponent";

    export default {
        name: "SharedHostingComponent",
        metaInfo: [
            {
                name: 'description',
                content: "",
            }
        ],
        data: () => {
            return {
                whmcsRoot: "https://my.cryo.host/",
                metaInfo: {
                    meta: [
                        {
                            name: "description",
                            content: "When building a website, start here. Our shared service delivers a powerful, proven platform that's perfect for hosting your websites."
                        }
                    ]
                },
                products: [
                       {
                        name: "Breeze",
                        description: 'This plan is perfect for getting a small static site online',
                        price: 1,
                        features: [
                            '512MB SSD Storage',
                            '1 Website/Domain',
                            '1 Email Account',
                            '1 Database',
                            'Unlimited Bandwidth'
                        ],
                        pid: '1'
                    },
                    {
                        name: "Chilly Gust",
                        description: 'This plan is suited for small businesses hoping to get their first website',
                        price: 3,
                        features: [
                            '1GB SSD Storage',
                            '2 Websites/Domains',
                            '5 Email Accounts',
                            '1 Database',
                            'Unlimited Bandwidth'
                        ],
                        pid: '2'
                    },
                    {
                        name: 'Freezing Winter',
                        description: 'This plan is for businesses with a slightly large site who need a lot of emails and resources',
                        price: 8,
                        features: [
                            '5GB SSD Storage',
                            '5 Websites/Domains',
                            '20 Email Accounts',
                            '5 Databases',
                            'Unlimited Bandwidth'
                        ],
                        pid: '3',
                        featured: true
                    },
                    {
                        name: "Ice Age",
                        description: 'This plan is for businesses with a large site who need a lot of resources. This is perfect for sites which expect heavy traffic',
                        price: 12,
                        features: [
                            '10GB SSD Storage',
                            'Unlimited Websites/Domains',
                            'Unlimited Email Accounts',
                            'Unlimited Databases',
                            'Unlimited Bandwidth'
                        ],
                        pid: '4'
                    }
                ]
            }
        }
        , components: {
            InnerPageBannerComponent,
            FrequentlyAskedQuestionsComponent
        }
        , methods: {
            productLink(pid) {
                return this.whmcsRoot + "cart.php?a=add&pid=".concat(pid)
            }
        }
    }
</script>

<style lang="scss" scoped>
    main.shared-hosting {
        padding-left: 20px;
        padding-right: 20px;

        .section-title {
            p {
                font-weight: 400;
                margin-top: 30px;
                font-size: 18px;
                line-height: 1.5;
            }
        }
    }
</style>